var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getCurrentRelatedProducts.length)?_c('section',{staticClass:"new-collection"},[_c('header',{staticClass:"container"},[_c('h2',[_vm._v(" "+_vm._s(_vm.heading)+" ")])]),_c('product-listing',{attrs:{"columns":"4","products":_vm.getCurrentRelatedProducts}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }